export interface MetricThresholds {
  successThreshold: number;
  dangerZoneWeeks: number;
}

export interface WorkspaceSectionLengths {
  wins: number;
  scorecard: number;
  rocks: number;
  tasks: number;
  issues: number;
  conclusion: number;
}

export const DEFAULT_WORKSPACE_SCORECARD_SETTINGS: MetricThresholds = {
  successThreshold: 80,
  dangerZoneWeeks: 3,
};

export const DEFAULT_WORKSPACE_MEETING_LENGTH = 90;

export const DEFAULT_WORKSPACE_SECTION_LENGTHS: WorkspaceSectionLengths = {
  wins: 5,
  scorecard: 5,
  rocks: 5,
  tasks: 5,
  issues: 60,
  conclusion: 5,
};

export function workspaceMetricThresholds(
  settings: Pick<MetricThresholds, 'successThreshold' | 'dangerZoneWeeks'> | null | undefined,
): MetricThresholds {
  return {
    successThreshold: settings?.successThreshold ?? DEFAULT_WORKSPACE_SCORECARD_SETTINGS.successThreshold,
    dangerZoneWeeks: settings?.dangerZoneWeeks ?? DEFAULT_WORKSPACE_SCORECARD_SETTINGS.dangerZoneWeeks,
  };
}

export function meetingSectionTargets(
  sections: ReadonlyArray<{ key: string; length: number }>,
  meetingType: string,
  workspaceDefaults: WorkspaceSectionLengths,
): Record<string, number> {
  return Object.fromEntries(sections.map((section) => {
    const workspaceDefault = meetingType === 'weekly'
      ? workspaceDefaults[section.key as keyof WorkspaceSectionLengths]
      : undefined;
    return [section.key, workspaceDefault ?? section.length];
  }));
}
